import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import PageNotFound from "../shared/presentations/PageNotFound";
import { Administration } from "./modules/administration/Administration";
import { Dashboard } from "./modules/dashboard/Dashboard";
import { TimeAndAttendance } from "./modules/time-and-attendance/TimeAndAttendance";
import { TimeOffManagement } from "./modules/time-off-management/TimeOffManagement";
import ProfileSummaryPage from "./pages/ProfileSummaryPage";

export const HomeRoutes = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={match.path + '/dashboard'} ><Dashboard /></Route>
      <Route path={match.path + '/administration'} ><Administration /></Route>
      <Route path={match.path + '/time-and-attendance'} ><TimeAndAttendance /></Route>
      <Route path={match.path + '/time-off-management'} ><TimeOffManagement /></Route>
      <Route path={match.path + '/manage-profile'} ><ProfileSummaryPage /></Route>
      <Redirect path={match.path + '/'} exact={true} to={match.path + '/administration'}></Redirect>
      <Route ><PageNotFound /></Route>
    </Switch>
  );
}